<template>
    <div id="qrcode-page" :style="{height: bodyHeight}">
        <div id="qrcode-box">
            <h2 class="code-title">在门店购物此商品时，向店铺店员展示二维码</h2>
            <div class="qr-img">
                <img :src="qrImg | urlProtocol" alt="">
            </div>
            <div class="qr-tips">
                <div class="qc-introduce">
                    凭此二维码到店，即可享受优品惊爆价优惠
                </div>
                <div class="activity-titme">
                    活动时间：{{time}}
                </div>
                <div>逾期作废</div>
            </div>
            <div class="store-box">
                <div class="box-center">
                    <div class="store-logo">
                        <img :src="storeLogo | urlProtocol" alt="">
                    </div>
                    <div class="store-info">
                        <h2>{{storeName}}</h2>
                        <div>
                            <span>{{address}}</span>
                            <span>/{{category}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import {Util} from '../commons/util'
    import Product from '@/components/commons/Product'

    export default {
        name: 'Order',
        data () {
            return {
                bodyHeight: '',
                qrImg: "",
                storeLogo: "",
                time: '',
                storeName: '',
                address: '',
                category: ''
            }
        },
        // 生命周期钩子
        mounted () {
            this.bodyHeight = window.screen.height + 'px';
            document.title = '二维码';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '二维码'
                        });
                    }
                })
            }
        },
        beforeRouteEnter(to, from, next) {

           next(vm => {
               let _this = vm,
                   data = JSON.parse(window.localStorage.qrdata),
                   startTime = Util.getStringTime(data.startTime),
                   endTime = Util.getStringTime(data.endTime);

               if (data) {

                   _this.qrImg = data.qrCodeUrl;
                   _this.storeLogo = data.shopLogo;
                   _this.time = startTime.Y + '.' + startTime.M + '.' + startTime.D + '-' + endTime.Y + '.' + endTime.M + '.' + endTime.D;
                   _this.storeName = data.shopName;
                   _this.address = data.floorName;
                   _this.category = data.shopBunk;

                   //window.location.reload();
               }
           });
        }
    }
</script>
<style scoped>
    #qrcode-page {
        box-sizing: border-box;
        padding: 20px;
        height: 100%;
        background: #f1f1f0;
    }
    #qrcode-box {
        height: auto;
        overflow: hidden;
        background: #fff;
        border-radius: 30px;


    }

    .code-title {
        margin-top: 103px;
        font-size:30px;
        color:#000000;
        text-align: center;
        font-weight: bold;
    }

    .qr-img {
        margin-left: auto;
        margin-right: auto;
        width: 500px;
        height: 500px;
        margin-top: 40px;

        img {
            display: block;
            overflow: hidden;
            width: 100%;
            height: 100%;
        }
    }
    .qr-tips {
        padding: 0 55px;
        margin-top: 40px;
        font-size:30px;
        color:#000000;
        font-weight: bold;
    }
    .activity-titme {
        margin-top: 22px;
        margin-bottom: 22px;
    }
    .store-box {
        border: 1px solid #000;
        width: 600px;
        height: 126px;
        margin: 44px auto;
        box-sizing: border-box;
        text-align: center;
        padding: 20px 50px 30px 50px;

        .box-center {

        }

        .store-logo {
            margin-right: 20px;
            /*float: left;*/
            display: inline-block;
            width: 100px;
            height: 80px;

            img {
                display: block;
                overflow: hidden;
                width: 100%;
                height: 100%;
            }
        }
        .store-info {
            text-align: left;
            display: inline-block;
            text-indent: 32px;
            position: relative;
            overflow: hidden;
            color: #ffaa00;

             span:nth-of-type(2) {
                 color: #bbb;
             }

             h2 {
                 text-align: left;
                 text-indent: 0;
                 color: #000;
             }

             >  div {
                position: relative;
                &:before {
                     content: '';
                     display: block;
                     width: 20px;
                     height: 26px;
                     position: absolute;
                     top: 50%;
                     margin-top: -11px;
                     background: url("../assets/loca-icon.png") 0 0 no-repeat;
                     background-size: 20px 26px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Qrcode.vue